import React from 'react';

const NotAuthorized = () => {
  return (
    <div className="text-center h-[100vh] flex items-center flex-col justify-center bg-primary text-white">
      <h1 className="text-3xl mb-16">403 - Forbidden</h1>
      <p>You do not have permission to access this page.</p>
    </div>
  );
};

export default NotAuthorized;
